import React, { useState } from 'react';
import { CountdownTimer } from '../components/CountdownTimer';
const testimonials = [{
  initials: 'CR',
  name: 'Carolina R.',
  location: 'Mendoza',
  product: 'Mega Pack + Método Sueño y Calma',
  quote: 'El Calendario de Crisis me salvó la semana 6. Estaba lista para dejar la lactancia porque creía que se me había ido la leche. Abrí el Método, leí que era una crisis de crecimiento y la esperé. En 4 días volvió a la normalidad. Ese calendario vale el precio del pack entero.'
}, {
  initials: 'RM',
  name: 'Romina M.',
  location: 'Buenos Aires',
  product: 'Mega Pack Mamá Primeriza',
  quote: 'El Tomo 5 fue lo que más me cambió la cabeza. No sabía que tenía derechos concretos en el parto. Fui con mi plan de parto impreso, se lo di a la enfermera cuando llegué y respetaron absolutamente todo. La epidural, el contacto piel a piel, el corte diferido del cordón. Todo.'
}, {
  initials: 'SC',
  name: 'Sofía C.',
  location: 'La Plata',
  product: 'Mega Pack Mamá Primeriza',
  quote: 'El Bono de Síntomas lo tenía abierto en el celular todo el tiempo. Cada vez que algo me preocupaba, primero iba ahí antes de googlear. Me ahorró horas de angustia innecesaria. Es lo más práctico que usé durante todo el embarazo.'
}, {
  initials: 'PA',
  name: 'Paula A.',
  location: 'Neuquén',
  product: 'Mega Pack + Método Sueño y Calma',
  quote: 'Las ventanas de sueño lo cambiaron absolutamente todo. Yo pensaba que si el bebé no dormía era porque tenía hambre y le ofrecía el pecho. Aprendí a leer sus señales de sueño y empecé a acostarlo antes. En una semana el primer bloque nocturno pasó de 2 horas a 4. Lloramos de alegría con mi pareja.'
}, {
  initials: 'JM',
  name: 'Julia M.',
  location: 'Córdoba',
  product: 'Mega Pack Mamá Primeriza',
  quote: 'La Guía Papá a Bordo la mandé a mi pareja la misma semana que recibí el pack. Me dijo que era la primera vez que entendía cómo ayudar de verdad y qué no decir. Los primeros 10 días en casa los manejamos como un equipo real. No lo hubiera creído si no lo vivía yo misma.'
}, {
  initials: 'TR',
  name: 'Tamara R.',
  location: 'Tucumán',
  product: 'Mega Pack + Método Sueño y Calma',
  quote: 'El Plan de Regreso a Casa lo imprimí en la semana 36 y lo pegué en la heladera antes de ir al sanatorio. Cuando llegamos con el bebé no tuve que pensar en absolutamente nada. Solo seguir el plan. Fue la diferencia entre el caos total y algo parecido a la calma.'
}, {
  initials: 'MF',
  name: 'Micaela F.',
  location: 'Santa Fe',
  product: 'Mega Pack Mamá Primeriza',
  quote: 'Compré el Mega Pack en la semana 8. Llegué al parto en la semana 39 habiendo leído todo, con el plan de parto en la cartera, el bolso listo hace 3 semanas y sin miedo. Mi obstetra dijo que era la paciente primeriza más preparada que había visto en años.'
}];
const faqs = [{
  q: '¿Sirve si estoy recién empezando el embarazo?',
  a: 'Sí. El Mega Pack está diseñado para acompañarte desde el primer positivo hasta los primeros 10 días con tu bebé en casa. Si estás en el primer trimestre, empezás por el Tomo 1 y avanzás a tu ritmo semana a semana. Si estás más avanzada, podés ir directamente al tomo que corresponde a tu momento actual.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'Inmediatamente después del pago recibís un email con el acceso a todos los tomos y bonos en formato PDF. Podés leerlos en el celular, en la computadora o imprimirlos en casa. El acceso es tuyo para siempre, sin vencimiento.'
}, {
  q: '¿Lo puedo usar si me atiendo en hospital público?',
  a: 'Sí. Todo el contenido está adaptado tanto para el sistema público como para obras sociales y prepagas de cualquier nivel. El Tomo 1 tiene una sección específica sobre los diferentes circuitos del sistema de salud argentino. La Ley 25.929 de Parto Humanizado aplica en todos los establecimientos de salud de Argentina sin excepción.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí. 30 días de garantía total sin preguntas ni condiciones. Si no quedás satisfecha con el material por cualquier motivo, escribís a nuestro email y te devolvemos el 100% del pago. Sin formularios, sin burocracia, sin drama.'
}, {
  q: '¿El Método Sueño y Calma sirve para lactancia materna y para fórmula?',
  a: 'Sí. Las técnicas de sueño del Método funcionan perfectamente independientemente del tipo de alimentación del bebé. Hay secciones específicas para lactancia (Dream Feed, técnicas de toma nocturna eficiente) y secciones adaptadas para biberón.'
}, {
  q: '¿Puedo compartirlo con mi pareja?',
  a: 'Sí. El Bono 5 (Guía Papá a Bordo) está específicamente diseñado para eso. Podés enviárselo directamente para que lo lea de manera independiente sin necesidad de que lea todo el pack.'
}, {
  q: '¿Qué pasa si me atienden en una localidad del interior del país?',
  a: 'El contenido aplica a todo el territorio argentino. Las leyes de salud, los derechos del embarazo y el parto, y los cuidados del bebé son iguales en todo el país. Lo que puede variar es la disponibilidad de ciertos servicios, y el pack te da las herramientas para navegar esas diferencias con información.'
}];
const costComparison = [{
  sin: 'Sin sistema de turnos y estudios organizado',
  costo: 'Olvidarte de estudios críticos o llegar a cada consulta sin las preguntas que realmente importan'
}, {
  sin: 'Sin guía de compras inteligente',
  costo: 'Miles de pesos en artículos de puericultura que el bebé nunca va a usar o que podían esperar'
}, {
  sin: 'Sin información sobre el plan de parto',
  costo: 'Parto vivido sin voz, sin derechos ejercidos y con intervenciones que quizás no eran necesarias'
}, {
  sin: 'Sin preparación física y mental para el trabajo de parto',
  costo: 'Llegar al día D sin técnicas de respiración ni herramientas reales de manejo del dolor'
}, {
  sin: 'Sin guía de síntomas',
  costo: 'Googlear cada molestia y terminar con más miedo que información concreta'
}, {
  sin: 'Sin plan de regreso a casa',
  costo: 'Primeras 72 horas en caos total cuando el cuerpo y la mente más necesitan descanso'
}, {
  sin: 'Sin Método Sueño y Calma',
  costo: 'Meses de agotamiento crónico que se podrían haber reducido significativamente con la información correcta'
}, {
  sin: 'Sin la Guía Papá a Bordo',
  costo: 'Pareja que quiere ayudar pero no sabe cómo y genera más trabajo del que resuelve'
}, {
  sin: 'Próximo domingo sin sistema',
  costo: 'El mismo ciclo de ansiedad, la semana que viene, el trimestre que viene'
}];
function FaqItem({
  q,
  a
}: {
  q: string;
  a: string;
}) {
  const [open, setOpen] = useState(false);
  return <div className="bg-white shadow-sm border border-pink-200 rounded-2xl overflow-hidden" data-id="element-179">
      <button onClick={() => setOpen(!open)} className="w-full flex items-center justify-between p-5 md:p-6 text-left font-bold text-base md:text-lg text-gray-900 hover:text-fuchsia-600 transition-colors" data-id="element-180">
        <span data-id="element-181">{q}</span>
        <svg className={`w-5 h-5 text-gray-400 shrink-0 ml-4 transition-transform ${open ? 'rotate-180' : ''}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} data-id="element-182">
          <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" data-id="element-183" />
        </svg>
      </button>
      {open && <div className="px-5 md:px-6 pb-5 md:pb-6 text-gray-600 leading-relaxed text-sm md:text-base border-t border-pink-100" data-id="element-184">
          <div className="pt-4" data-id="element-185">{a}</div>
        </div>}
    </div>;
}
export function TrustSection() {
  return <section className="py-16 md:py-24 border-t border-pink-200 bg-white/30 backdrop-blur-sm" data-id="element-186">
      <div className="max-w-6xl mx-auto px-4" data-id="element-187">
        {/* Testimonials */}
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-10 md:mb-16" data-id="element-188">
          ❤️ MÁS MAMÁS QUE YA LO TIENEN
        </h2>

        <div className="grid md:grid-cols-2 gap-5 md:gap-6 max-w-4xl mx-auto mb-20 md:mb-28" data-id="element-189">
          {testimonials.map((t, i) => <div key={i} className="bg-white shadow-lg border border-pink-200 rounded-2xl p-6 md:p-8" data-id="element-190">
              <div className="flex items-center gap-3 md:gap-4 mb-5" data-id="element-191">
                <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-fuchsia-50 text-fuchsia-600 flex items-center justify-center font-bold text-base md:text-xl border border-fuchsia-200" data-id="element-192">
                  {t.initials}
                </div>
                <div data-id="element-193">
                  <div className="text-fuchsia-500 text-xs tracking-wider mb-0.5" data-id="element-194">
                    ★★★★★
                  </div>
                  <div className="text-gray-900 font-bold text-sm md:text-base" data-id="element-195">
                    {t.name}{' '}
                    <span className="text-gray-500 font-normal text-xs md:text-sm ml-1" data-id="element-196">
                      📍 {t.location}
                    </span>
                  </div>
                  <div className="text-xs text-fuchsia-600/80 font-medium mt-0.5" data-id="element-197">
                    | {t.product}
                  </div>
                </div>
              </div>
              <p className="text-gray-700 italic text-sm md:text-lg leading-relaxed" data-id="element-198">
                "{t.quote}"
              </p>
            </div>)}
        </div>

        {/* Guarantee */}
        <div className="max-w-3xl mx-auto bg-gradient-to-br from-white to-pink-50 shadow-xl border border-pink-200 rounded-2xl md:rounded-3xl p-8 md:p-14 text-center mb-20 md:mb-28 relative overflow-hidden" data-id="element-199">
          <div className="absolute top-0 left-0 w-full h-1.5 bg-fuchsia-400" data-id="element-200" />
          <div className="text-6xl md:text-7xl mb-6" data-id="element-201">🛡️</div>
          <h2 className="text-2xl md:text-4xl font-bold text-gray-900 mb-5" data-id="element-202">
            GARANTÍA 30 DÍAS — SIN PREGUNTAS
          </h2>
          <p className="text-base md:text-xl text-gray-700 mb-6 leading-relaxed" data-id="element-203">
            Abrís los tomos. Los usás durante tu embarazo.
            <br data-id="element-204" />
            Si en 30 días de uso honesto no considerás que vale al menos 10
            veces lo que pagaste:
            <br data-id="element-205" />
            <strong className="text-gray-900" data-id="element-206">devolución del 100%</strong>
            <br data-id="element-207" />
            sin formularios, sin drama, sin preguntas.
          </p>
          <div className="inline-block bg-white shadow-sm px-5 py-2.5 rounded-full text-fuchsia-600 font-medium border border-pink-200 text-sm" data-id="element-208">
            Tasa de devoluciones: menos del 1%.
          </div>
        </div>

        {/* FAQ */}
        <div className="max-w-3xl mx-auto mb-20 md:mb-28" data-id="element-209">
          <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-10 md:mb-12" data-id="element-210">
            ❓ LO QUE MÁS NOS PREGUNTAN
          </h2>
          <div className="space-y-3 md:space-y-4" data-id="element-211">
            {faqs.map((faq, i) => <FaqItem key={i} q={faq.q} a={faq.a} data-id="element-212" />)}
          </div>
        </div>

        {/* Cost Comparison */}
        <div className="max-w-4xl mx-auto mb-20 md:mb-28" data-id="element-213">
          <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-10 md:mb-12" data-id="element-214">
            ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
          </h2>
          <div className="bg-white shadow-xl border border-pink-200 rounded-2xl md:rounded-3xl overflow-hidden" data-id="element-215">
            <div className="overflow-x-auto" data-id="element-216">
              <table className="w-full text-left min-w-[500px]" data-id="element-217">
                <thead data-id="element-218">
                  <tr className="bg-pink-50" data-id="element-219">
                    <th className="p-4 md:p-6 text-gray-700 font-semibold text-sm border-b border-pink-200 w-1/2" data-id="element-220">
                      Sin Mega Pack Mamá Primeriza
                    </th>
                    <th className="p-4 md:p-6 text-red-500 font-semibold text-sm border-b border-pink-200 w-1/2" data-id="element-221">
                      Costo real
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-222">
                  {costComparison.map((row, i) => <tr key={i} className="border-b border-pink-100 hover:bg-pink-50/50 transition-colors" data-id="element-223">
                      <td className="p-4 md:p-6 text-gray-900 font-medium text-sm" data-id="element-224">
                        {row.sin}
                      </td>
                      <td className="p-4 md:p-6 text-gray-600 text-sm" data-id="element-225">
                        {row.costo}
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Final CTA */}
        <div className="max-w-4xl mx-auto text-center bg-white shadow-2xl border border-fuchsia-200 rounded-2xl md:rounded-3xl p-6 md:p-14 relative overflow-hidden" data-id="element-226">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-xl h-[250px] rounded-full pointer-events-none" style={{
          background: 'radial-gradient(circle, rgba(232,121,249,0.1) 0%, transparent 70%)'
        }} data-id="element-227" />

          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6 relative z-10" data-id="element-228">
            El próximo domingo puede ser diferente.
          </h2>

          <div className="mb-10 relative z-10" data-id="element-229">
            <div className="text-red-500 font-bold mb-4 uppercase tracking-wider text-sm" data-id="element-230">
              ⏰ EL PRECIO CIERRA EN:
            </div>
            <CountdownTimer data-id="element-231" />
          </div>

          <div className="flex flex-col md:flex-row gap-4 md:gap-6 justify-center relative z-10 mb-10" data-id="element-232">
            <a href="https://www.nexorecursos.com/cart/52509436772628:1" className="flex-1 bg-gray-100 hover:bg-gray-200 text-gray-900 font-bold py-5 px-6 rounded-2xl transition-colors border border-gray-200 flex flex-col items-center justify-center gap-1 shadow-sm" data-id="element-233">
              <span className="text-lg md:text-xl" data-id="element-234">
                MEGA PACK MAMÁ PRIMERIZA™
              </span>
              <span className="text-fuchsia-600 font-bold" data-id="element-235">$19.990 ARS</span>
              <span className="text-xs font-normal text-gray-500 mt-1" data-id="element-236">
                → QUIERO MI MEGA PACK AHORA
              </span>
            </a>
            <a href="https://www.nexorecursos.com/cart/52509446570260:1" className="animate-pulse-glow flex-1 bg-fuchsia-500 hover:bg-fuchsia-600 text-white font-bold py-5 px-6 rounded-2xl transition-all active:scale-95 flex flex-col items-center justify-center gap-1 shadow-lg shadow-fuchsia-500/30" data-id="element-237">
              <span className="text-lg md:text-xl" data-id="element-238">
                MEGA PACK + MÉTODO SUEÑO Y CALMA ⭐
              </span>
              <span className="text-white font-bold" data-id="element-239">$27.990 ARS</span>
              <span className="text-xs font-bold text-fuchsia-100 mt-1" data-id="element-240">
                → QUIERO EL MEGA PACK + MÉTODO SUEÑO Y CALMA
              </span>
            </a>
          </div>

          <div className="flex flex-wrap justify-center items-center gap-4 md:gap-6 text-xs md:text-sm font-medium text-gray-500 relative z-10" data-id="element-241">
            <span data-id="element-242">🔒 Pago 100% seguro</span>
            <span data-id="element-243">⚡ Acceso en 5 minutos</span>
            <span data-id="element-244">🛡️ Garantía 30 días</span>
            <span data-id="element-245">💳 Mercado Pago | Tarjeta | Transferencia</span>
          </div>
        </div>
      </div>
    </section>;
}